import http from "../http";

const LdapSyncService = {
    getSegmentsService: async () => {
        const segments = await http.instance.get("/ldapsync/segments");
        return segments.data
    },

    getSegmentService: async (payload) => {
        const segment = await http.instance.get("/ldapsync/segments/" + payload)
        return segment.data;
    },

    getSystemsService: async () => {
        const systems = await http.instance.get("/ldapsync/systems");
        return systems.data
    },

    AddSegmentService: async (form) => {
        const segment = await http.instance.post("/ldapsync/addsegment", form)
        return segment;
    },

    DeleteSegmentService: async (payload) => {
        const deletesegment = await http.instance.post("/ldapsync/deletesegment/" + payload)
        return deletesegment;
    },
    syncDataService: async (value) => {
        const syncData = await http.instance.get("/ldapsync/sync/" + value)
        return syncData.data;

    }
};
export default LdapSyncService;
